<template>
  <div class="mx-4">
    <div v-bind:class="loading">
      <div class="d-flex justify-content-center">
        <div class="spinner-border m-5" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </div>
    <div v-bind:class="result">
      <div class="row">
        <div class="col-12 pb-0" style="display: flex; justify-content: center">
          <h4 class="mb-0">Ausencias</h4>
        </div>
        <div class="col-12 pt-0" style="display: flex; justify-content: flex-end">
          <v-btn color="primary" elevation="1" @click="Consultar">Consultar</v-btn>
        </div>
        <div class="col-12 mt-3">
          <v-card>
            <v-card-title style="display: flex; justify-content: flex-end">
              <v-col cols="12">
                <v-row style="display: flex; align-items: flex-end">
                  <v-col cols="3" class="pa-1 mx-2">
                    <v-dialog ref="dialogBegin" v-model="modalBegin" :return-value.sync="begin" persistent width="290px">
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="dateRangeText"
                          label="Rango de fechas"
                          prepend-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          hide-details
                          class="pr-2 pb-1"
                        ></v-text-field>
                      </template>
                      <v-date-picker :title-date-format="titleDateFormat" v-model="begin" range locale="es">
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="modalBegin = false"> Cancelar </v-btn>
                        <v-btn text color="primary" @click="$refs.dialogBegin.save(begin)"> OK </v-btn>
                      </v-date-picker>
                    </v-dialog>
                  </v-col>
                  <v-spacer></v-spacer>
                  <v-col cols="2" class="pa-1 mx-2">
                    <v-text-field
                      hide-details
                      solo
                      v-model="send.idencargado"
                      label="MU"
                      dense
                      no-data-text="No se obtuvieron resultados"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="2" class="pa-1 mx-2">
                    <v-text-field
                      hide-details
                      solo
                      v-model="send.idfirmarse_sistema"
                      label="Agente"
                      dense
                      no-data-text="No se obtuvieron resultados"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="2" class="pa-1 mx-2">
                    <v-autocomplete
                      hide-details
                      solo
                      v-model="send.nomestatus"
                      :items="filter.nomestatus"
                      label="Estatus"
                      dense
                      no-data-text="No se obtuvieron resultados"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="2" class="pa-1 mx-2">
                    <v-autocomplete
                      hide-details
                      solo
                      v-model="send.motivo"
                      :items="filter.motivo"
                      label="Motivo"
                      dense
                      no-data-text="No se obtuvieron resultados"
                    ></v-autocomplete>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="8" class="pa-1">
                <v-btn elevation="2" @click="cleanFilter">Limpiar</v-btn>
              </v-col>
              <v-col cols="4">
                <v-text-field v-model="search" append-icon="mdi-magnify" label="Buscar" single-line hide-details></v-text-field>
              </v-col>
            </v-card-title>
            <v-data-table
              :headers="headers"
              :items="items"
              :search="search"
              :page.sync="page"
              :items-per-page="itemsPerPage"
              class="elevation-1"
              hide-default-footer
              loading-text="Cargando usuarios... Porfavor espere"
            >
              <template v-slot:item.fechas="{ item }">
                <span v-text="item.hora_inicio_evento + ' - ' + item.hora_fin_evento" />
              </template>
              <template v-slot:[`item.actions`]="{ item }">
                <div v-if="item.status == '3'" style="display: flex">
                  <button class="btn btn-success btn-sm" v-on:click.prevent="Autorizar_Ausencia(item.idretardo_ausencia)">
                    Asignar Undertime
                  </button>
                  <button class="btn btn-danger btn-sm" v-on:click.prevent="Rechazar_Ausencia(item.idretardo_ausencia)">
                    No Asignar Undertime
                  </button>
                </div>
              </template>
              <template v-slot:no-data> No hay información disponible </template>
              <template v-slot:no-results> No se obtuvieron resultados </template>
            </v-data-table>
            <PaginationFooter
              @sendItemsPerPage="getItemsPerPage"
              @lastClic="lastClic"
              @nextClic="nextClic"
              :page="page"
              :itemsLength="itemsLength"
            />
          </v-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import GeneralMixin from "@/components/mixins/General";
import PaginationFooter from "@/components/General/PaginationFooter";
import axios from "axios";
import moment from "moment-timezone";

export default {
  mixins: [GeneralMixin],
  components: {
    PaginationFooter,
  },
  data() {
    return {
      url: process.env.VUE_APP_URL,
      headers: [
        { text: "Clave", align: "left", sortable: false, value: "idretardo_ausencia" },
        { text: "MU", align: "start", value: "idencargado" },
        { text: "ID", align: "left", value: "idagente_sistema" },
        { text: "Agente", align: "left", value: "idfirmarse_sistema" },
        { text: "Nombre Agente", align: "left", value: "nomagente_sistema" },
        { text: "Fecha Solicitada", align: "left", sortable: false, value: "fecha_evento" },
        { text: "Horas", align: "left", value: "fechas" },
        { text: "Estatus", align: "left", value: "nomestatus" },
        { text: "Motivos", align: "left", value: "motivo" },
        { text: "Acciones", align: "center", value: "actions" },
      ],
      items: [],
      itemsBackup: [],
      filter: {
        nomestatus: [
          "Pendiente de Autorizar",
          "No Autorizado",
          "Autorizado",
          "En Proceso por Servidor",
          "Procesado por Servidor",
          "Error al procesar",
        ],
        motivo: ["Consulta Médica", "Compromisos Personales", "Problemas de Transportacion", "Problemas Tecnicos", "Compromisos Escolares"],
      },
      send: {
        idencargado: "",
        idfirmarse_sistema: "",
        nomestatus: "",
        motivo: "",
      },
      modalBegin: false,
      search: "",
      loading: "",
      result: "d-none",
      ausencias: [],
      maxPages: 1000,
      begin: [],
      data: {
        skip: 1,
        take: 10,
        filters: {
          fechas: this.begin,
        },
      },
      page: 1,
      itemsPerPage: 10,
      itemsLength: 0,
    };
  },
  methods: {
    getItemsPerPage(dato) {
      this.itemsPerPage = parseInt(dato);
      this.page = 1;
      this.data = {
        skip: this.page,
        take: this.itemsPerPage,
        filters: {
          fechas: this.begin,
          mu: this.send.idencargado ? this.send.idencargado : undefined,
          agente: this.send.idfirmarse_sistema ? this.send.idfirmarse_sistema : undefined,
          motivo: this.send.motivo ? this.send.motivo : undefined,
          status: this.send.nomestatus ? this.send.nomestatus : undefined,
        },
      };
      this.Consultar();
    },
    lastClic() {
      this.page--;
      this.data = {
        skip: this.page,
        take: this.itemsPerPage,
        filters: {
          fechas: this.begin,
          mu: this.send.idencargado ? this.send.idencargado : undefined,
          agente: this.send.idfirmarse_sistema ? this.send.idfirmarse_sistema : undefined,
          motivo: this.send.motivo ? this.send.motivo : undefined,
          status: this.send.nomestatus ? this.send.nomestatus : undefined,
        },
      };
      this.Consultar();
    },
    nextClic() {
      this.page++;
      this.data = {
        skip: this.page,
        take: this.itemsPerPage,
        filters: {
          fechas: this.begin,
          mu: this.send.idencargado ? this.send.idencargado : undefined,
          agente: this.send.idfirmarse_sistema ? this.send.idfirmarse_sistema : undefined,
          motivo: this.send.motivo ? this.send.motivo : undefined,
          status: this.send.nomestatus ? this.send.nomestatus : undefined,
        },
      };
      this.Consultar();
    },
    async Consultar() {
      this.Cargando();
      try {
        // A futuro cambiara la estructura del proyecto y esto quedara en el router estos dos headers
        axios.defaults.headers.common["Authorization"] = "Bearer " + localStorage.getItem("apiKey_tp");
        axios.defaults.headers.common["accesstoken"] = localStorage.getItem("tokenmsal");
        if (this.begin.length < 2) {
          this.begin[1] = this.begin[0];
        }

        const url = this.url + "v2/api/admin/filter/ausencias";
        let data = (this.data = {
          skip: this.page,
          take: this.itemsPerPage,
          filters: {
            fechas: this.begin,
            mu: this.send.idencargado ? this.send.idencargado : undefined,
            agente: this.send.idfirmarse_sistema ? this.send.idfirmarse_sistema : undefined,
            motivo: this.send.motivo ? this.send.motivo : undefined,
            status: this.send.nomestatus ? this.send.nomestatus : undefined,
          },
        });
        const {
          data: { data: items, count },
        } = await axios.post(url, { data });
        this.items = items.map((obj) => {
          return {
            ...obj,
            fecha_evento: moment(obj.fecha_evento).utc().format("YYYY-MM-DD"),
          };
        });
        this.itemsLength = count;
        this.itemsBackup = this.items;

        if (this.items != null) {
          this.ausencias = this.items;
        }
        if (this.ausencias.length === 0) {
          swal("No hay ausencias", "Por el momento no hay solicitudes", "info");
        }
        this.loading = "d-none";
        this.result = "";
      } catch (error) {
        if (error.body?.code === "MSAL_TOKEN_IS_NOT_VALID") {
          this.$msal.signOut();
        }
        if (error.response.data.code === "INVALID_TOKEN") {
          // Redirigir al usuario a la página de inicio de sesión
          this.$msal.signOut();
          this.$router.push({ name: "Login" });
        }
        if (error.status !== 401) {
          swal("Problemas para conectarse", "Favor de revisar su conexión a internet", "error");
        }
        this.Listo();
      }
    },
    Autorizar_Ausencia(idretardo_ausencia) {
      var that = this;
      swal({
        title: "¿Seguro que desea autorizar la solicitud?",
        text: 'Presiona "OK" para autorizar, "Cancel" para cancelar',
        icon: "info",
        buttons: true,
        dangerMode: true,
      }).then((willDelete) => {
        if (willDelete) {
          that.Si_Autorizar_Ausencia(idretardo_ausencia);
        } else {
        }
      });
    },
    Rechazar_Ausencia(idretardo_ausencia) {
      var that = this;
      swal({
        title: "¿Seguro que desea rechazar la solicitud?",
        text: 'Presiona "OK" para rechazar, "Cancel" para cancelar',
        icon: "info",
        buttons: true,
        dangerMode: true,
      }).then((willDelete) => {
        if (willDelete) {
          that.No_Autorizar_Ausencia(idretardo_ausencia);
        } else {
        }
      });
    },
    Si_Autorizar_Ausencia(idretardo_ausencia) {
      var that = this;
      this.Cargando();

      const url = this.Obtener_Url("web/ausencias/autorizar/" + idretardo_ausencia);
      this.$http
        .post(
          url,
          {},
          {
            headers: this.get_request_headers({
              accesstoken: localStorage.getItem("tokenmsal"),
            }),
          }
        )
        .then((respuesta) => {
          return respuesta.json();
        })
        .then((respuestaJson) => {
          if (respuestaJson.resp == "Excelente") {
            swal("Ausencia Autorizada", "La Ausencia fue autorizado con exito", "success");
            this.Consultar();
          } else {
            swal(respuestaJson.resp, "Favor de intentar de nuevo", "error");
            this.Listo();
          }
        })
        .catch((error) => {
          if (error.body.code == "MSAL_TOKEN_IS_NOT_VALID") {
            //this.$msal.signOut();
          }
          swal("Problemas para conectarse", "Favor de revisar su conexión a internet", "error");
          this.Listo();
        });
    },
    Listo() {
      var that = this;
      this.loading = "d-none";
      this.result = "";
    },
    No_Autorizar_Ausencia(idretardo_ausencia) {
      var that = this;
      this.Cargando();

      const url = this.Obtener_Url("web/ausencias/rechazar/" + idretardo_ausencia);
      this.$http
        .post(
          url,
          {},
          {
            headers: this.get_request_headers({
              accesstoken: localStorage.getItem("tokenmsal"),
            }),
          }
        )
        .then((respuesta) => {
          return respuesta.json();
        })
        .then((respuestaJson) => {
          if (respuestaJson.resp == "Excelente") {
            swal("Ausencia Rechazada", "La Ausencia fue rechazada con exito", "success");
            this.Consultar();
          } else {
            swal(respuestaJson.resp, "Favor de intentar de nuevo", "error");
            this.Listo();
          }
        })
        .catch((error) => {
          if (error.body.code == "MSAL_TOKEN_IS_NOT_VALID") {
            this.$msal.signOut();
          }
          swal("Problemas para conectarse", "Favor de revisar su conexión a internet", "error");
          this.Listo();
        });
    },
    Cargando() {
      this.loading = "";
      this.result = "d-none";
    },
    Ver_Retardo(idausencia) {
      this.$router.push({
        name: "Retardo",
        params: { idausencia: idausencia },
      });
    },
    cleanFilter() {
      for (let key in this.send) {
        this.send[key] = "";
      }
      this.Consultar();
    },
  },
  computed: {
    menu() {
      return this.$store.getters.getMenu;
    },
    dateRangeText() {
      return this.begin.join(" ~ ");
    },
    titleDateFormat() {
      // Aquí puedes incluir la clase personalizada en la cadena de formato de fecha
      return (date) => {
        return this.$vuetify.lang.t("Fechas seleccionadas");
      };
    },
  },
  created() {
    const today = new Date();
    const sevenDaysAgo = new Date(today);
    sevenDaysAgo.setDate(today.getDate() - 7);
    this.begin = [sevenDaysAgo.toISOString().substr(0, 10), new Date().toISOString().substr(0, 10)];
    this.Consultar();
  },
};
</script>

<style>
.v-select__selection--comma {
  font-size: 0.75rem;
}
</style>
